import { put, select, takeLatest } from 'redux-saga/effects'
import { StateCustomDataConstants } from '../store/nemsisCustomData.constants'
import { ISingleStateCustomElement, IStateCustomDataDisplayState } from '../store/nemsisCustomData.types'
import { setCustomDisplayData } from '../store/nemsisCustomData.actions'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { getStateCustomDisplayDataSelector } from '../selectors/stateCustomDisplayData.selector'

export function* setMultiInstancePnnvValue() {
  try {
    const customDisplayData: IStateCustomDataDisplayState = yield select(getStateCustomDisplayDataSelector)
    const {
      groupId,
      stateCustomElements,
      groupingSequence,
      customElementId,
      customElementMultiInstancePNNVValue,
      key,
      groupKey,
    } = customDisplayData

    const stateCustomElementsCopy = [...stateCustomElements]
    const updatedStateCustomElements = stateCustomElementsCopy.map((stateElements: ISingleStateCustomElement) => {
      return {
        ...stateElements,
        groups: stateElements.groups.map((elementGroup) => {
          if (
            elementGroup.groupId !== groupId ||
            elementGroup.groupKey !== groupKey ||
            elementGroup.groupingSequence !== groupingSequence
          ) {
            return elementGroup
          } else {
            return {
              ...elementGroup,
              customElements: elementGroup.customElements.map((customElement) => {
                const isMatch =
                  customElement.id === customElementId && (!customElement.key || customElement.key === key)
                if (isMatch) {
                  return {
                    ...customElement,
                    results: [],
                    resultsPNNV: customElementMultiInstancePNNVValue,
                    _pnnvToggle: true,
                  }
                } else {
                  return customElement
                }
              }),
            }
          }
        }),
      }
    })
    yield put(setCustomDisplayData(updatedStateCustomElements))
  } catch (e) {
    yield put(throwPcrException(`setMultiInstancePnnvValueSaga() error: ${e}`))
  }
}

export function* setMultiInstancePnnvValueSaga() {
  yield takeLatest(
    [StateCustomDataConstants.SET_STATE_MULTI_INSTANCE_CUSTOM_ELEMENT_PNNV_VALUE],
    performWithMutexHOG,
    setMultiInstancePnnvValue
  )
}
